<template>
  <div id="aboutUs">
    <v-form ref="aboutForm">
      <v-container>
        <v-layout class="pr-4 pl-4 hidden-sm-and-up button-container">
          <v-flex xs12 sm12 md12 v-if="isFormDataChanged" class="pr-0 text-xs-right">
            <div class="d-inline-flex">
              <v-btn class="pf-btn pf-btn-cancel" @click="hideButtons">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
        <v-layout wrap class="pr-4 pl-4">
            <v-flex xs12 sm6 md6 pl-0>
              <div class="pt-2">
                  <div class="mt-0 left pr-3 switch-account">
                    <v-label class="">{{ form.accountType.label }}</v-label>
                  </div>
                  <div class="pt-1">  
                     <label class="switch-cover">
                      <input type="radio" v-model="accountDetails.account_type" name="radio" id="couple" value="Couple" @change="changeAccountType($event.target.value)">
                      <span class="checkmark">{{ form.accountType.coupleText }}</span>
                    </label>
                    <label class="switch-cover">
                      <input type="radio" v-model="accountDetails.account_type" id="single" name="radio" value="Single" @change="changeAccountType($event.target.value)">
                      <span class="checkmark">{{ form.accountType.singleText }}</span>
                    </label>
                  </div>
              </div>
            </v-flex>
            <v-flex xs12 sm6 md6 class="button-container pr-0 text-xs-right hidden-xs-only">
              <div class="d-inline-flex" v-if="isFormDataChanged">
                <v-btn class="pf-btn pf-btn-cancel" @click="hideButtons">
                  <v-icon size="16" class="pr-1">cancel</v-icon>
                  <div>Cancel</div>
                </v-btn>
                <v-btn class="pf-btn pf-btn-save" @click="save">
                  <v-icon size="16" class="pr-1">check_circle</v-icon>
                  <div>Save</div>
                </v-btn>
              </div>
            </v-flex>
        </v-layout>

        <v-layout wrap class="pb-4 pt-3">
            <v-flex xs12 sm12 class="pr-4 pl-4">
              <h5 class="text-uppercase font-weight-bold">{{accountDetails.account_type === 'Single' ? 'Parent' : 'Parent 1'}}</h5>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-text-field v-model.trim="accountDetails.human[0].first_name" :rules="form.parent1.fields.firstName.rules" :label="form.parent1.fields.firstName.label"
              class="required pr-4 pl-4" @input="isFormDataChanged = true"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-text-field v-model="accountDetails.human[0].last_name" :label="form.parent1.fields.lastName.label" class="pr-4 pl-4" @input="isFormDataChanged = true"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-select v-model="accountDetails.human[0].gender" :label="form.parent1.fields.gender.label" :items="form.data.genders" class="pr-4 pl-4" @change="isFormDataChanged = true"></v-select>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-menu
                ref="accountDetails.human[0].birth_date"
                v-model="form.parent1.fields.dob.picker"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="parent1DobFormatted"
                    :label="form.parent1.fields.dob.label"
                    hint="MM/DD/YYYY"
                    persistent-hint
                    readonly 
                    clearable
                    prepend-icon="event"
                    @blur="accountDetails.human[0].birth_date = parseDate(parent1DobFormatted); isFormDataChanged = true"
                    v-on="on"
                    class="pr-4 pl-4"
                    @input="isFormDataChanged = true"
                  ></v-text-field>
                </template>
                <v-date-picker color="#019d8c" :max="new Date().toISOString().substr(0, 10)" v-model="accountDetails.human[0].birth_date"
                @input="form.parent1.fields.dob.picker = false">
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-select v-model="accountDetails.human[0].ethnicity" :small-chips="accountDetails.human[0].ethnicity !== ''" :deletable-chips="accountDetails.human[0].ethnicity !== ''" :label="form.parent1.fields.ethinicity.label" :items="form.data.ethnicities" class="pr-4 pl-4" @change="isFormDataChanged = true"></v-select>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-select v-model="accountDetails.human[0].education" :small-chips="accountDetails.human[0].education !== ''" :deletable-chips="accountDetails.human[0].education !== ''" :label="form.parent1.fields.education.label" :items="form.data.educations" class="pr-4 pl-4" @change="isFormDataChanged = true"></v-select>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <v-select v-model="accountDetails.human[0].religion" :small-chips="accountDetails.human[0].religion !== ''" :deletable-chips="accountDetails.human[0].religion !== ''" :label="form.parent1.fields.religion.label" :items="form.data.religions" class="pr-4 pl-4" @change="isFormDataChanged = true"></v-select>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-text-field v-model="accountDetails.human[0].occupation" :label="form.parent1.fields.occupuation.label" required class="pr-4 pl-4" @input="isFormDataChanged = true"></v-text-field>
            </v-flex>
            <v-flex xs12 sm4>
            </v-flex>

        </v-layout>
        <v-layout wrap class="pb-4" v-if="accountDetails.account_type === 'Couple'">
           <v-flex xs12 sm12 class="pr-4 pl-4">
              <h5 class="text-uppercase font-weight-bold">{{form.parent2.title}}</h5>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-text-field required v-model.trim="accountDetails.human[1].first_name" :rules="[ parent2FirstNameRule ]" :label="form.parent2.fields.firstName.label"
              class="required pr-4 pl-4" @input="isFormDataChanged = true"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-text-field v-model="accountDetails.human[1].last_name" :label="form.parent2.fields.lastName.label" class="pr-4 pl-4" @input="isFormDataChanged = true"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-select v-model="accountDetails.human[1].gender" :label="form.parent2.fields.gender.label" :items="form.data.genders" class="pr-4 pl-4" @change="isFormDataChanged = true"></v-select>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-menu
                v-model="form.parent2.fields.dob.picker"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="parent2DobFormatted"
                    :label="form.parent2.fields.dob.label"
                    hint="MM/DD/YYYY"
                    persistent-hint
                    readonly 
                    clearable
                    prepend-icon="event"
                    @blur="accountDetails.human[1].birth_date = parseDate(parent2DobFormatted); isFormDataChanged = true"
                    v-on="on"
                    class="pr-4 pl-4"
                    @input="isFormDataChanged = true"
                  ></v-text-field>
                </template>
                <v-date-picker color="#019d8c" :max="new Date().toISOString().substr(0, 10)" v-model="accountDetails.human[1].birth_date" @input="form.parent2.fields.dob.picker = false"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-select v-model="accountDetails.human[1].ethnicity" :small-chips="accountDetails.human[1].ethnicity !== ''" :deletable-chips="accountDetails.human[1].ethnicity !== ''" :label="form.parent2.fields.ethinicity.label" :items="form.data.ethnicities" class="pr-4 pl-4" @change="isFormDataChanged = true"></v-select>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-select v-model="accountDetails.human[1].education" :small-chips="accountDetails.human[1].education !== ''" :deletable-chips="accountDetails.human[1].education !== ''" :label="form.parent2.fields.education.label" :items="form.data.educations" class="pr-4 pl-4" @change="isFormDataChanged = true"></v-select>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <v-select v-model="accountDetails.human[1].religion" :small-chips="accountDetails.human[1].religion !== ''" :deletable-chips="accountDetails.human[1].religion !== ''" :label="form.parent2.fields.religion.label" :items="form.data.religions" class="pr-4 pl-4" @change="isFormDataChanged = true"></v-select>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-text-field v-model="accountDetails.human[1].occupation" :label="form.parent2.fields.occupuation.label" required class="pr-4 pl-4" @input="isFormDataChanged = true"></v-text-field>
            </v-flex>
            <v-flex xs12 sm4>
            </v-flex>
        </v-layout>
        <v-layout wrap> 

            <v-flex xs12 sm12 class="pr-4 pl-4">
              <h5 class="text-uppercase font-weight-bold">{{ 'General Information' }}</h5>
            </v-flex>
            <!-- <v-flex xs12 sm6 md4>
              <v-select v-model="accountDetails.waiting_for" label="Waiting Since" :items="form.data.waitingFors" class="pr-4 pl-4" @change="isFormDataChanged = true"></v-select>
            </v-flex> -->
            <v-flex xs12 sm6 md4>
              <v-select v-model="accountDetails.family_structure" :small-chips="accountDetails.family_structure !== ''" :deletable-chips="accountDetails.family_structure !== ''" label="Family Structure" :items="form.data.familyStructures" class="pr-4 pl-4" @change="isFormDataChanged = true"></v-select>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-select v-model="accountDetails.house_style" :small-chips="accountDetails.house_style !== ''" :deletable-chips="accountDetails.house_style !== ''" label="Your House Type" :items="form.data.houseTypes" class="pr-4 pl-4" @change="isFormDataChanged = true"></v-select>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <v-select v-model="accountDetails.neighbourhood_like" :small-chips="accountDetails.neighbourhood_like !== ''" :deletable-chips="accountDetails.neighbourhood_like !== ''" label="Your Neighbourhood" :items="form.data.neighbourhoods" class="pr-4 pl-4" @change="isFormDataChanged = true"></v-select>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-select
                v-model="accountDetails.pets"
                :items="form.data.pets"
                label="Your Pets"
                multiple
                small-chips
                deletable-chips
                class="pr-4 pl-4"
                @change="changePets(accountDetails.pets)"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-select v-model="accountDetails.children_count" small-chips deletable-chips label="Your Children" :items="form.data.childrens" class="pr-4 pl-4" @change="isFormDataChanged = true"></v-select>
            </v-flex>
        </v-layout>
        <v-layout class="button-container pr-4 pl-4">
          <v-flex xs12 sm12 md12 v-if="isFormDataChanged" class="pr-0 text-xs-right">
            <div class="d-inline-flex">
              <v-btn class="pf-btn pf-btn-cancel" @click="hideButtons">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>
<script>
/* global session store */
/* eslint complexity: ["error", 22] */
import { mapGetters } from 'vuex';
import { create, getOne, update, remove } from '../helpers/helpers';
import swal from 'sweetalert2';

export default {
  data: vm => ({
    accountDetails: {},
    loading: false,
    parent1Dob: null,
    parent2Dob: null,
    parent1DobFormatted: null,
    parent2DobFormatted: null,
    isFormDataChanged: false,
    nonEditedData: {},
    previousPetsList: [],
    form: {
      accountType: {
        label: 'Account Type',
        defaultText: 'Couple',
        coupleText: 'Couple',
        singleText: 'Single',
        value: false
      },
      waitingFor: {
        label: 'Waiting Since',
        value: ''
      },
      familyStructure: {
        label: 'Family Structure',
        value: ''
      },
      houseType: {
        label: 'Your House Type',
        value: ''
      },
      neighbourhood: {
        label: 'Your Neighbourhood',
        value: ''
      },
      pet: {
        label: 'Your Pets',
        value: ''
      },
      children: {
        label: 'Your Children',
        value: ''
      },
      childAge1: {
        label: 'Age (1st Child)',
        value: ''
      },
      childAge2: {
        label: 'Age (2nd Child)',
        value: '' 
      },
      generalInfoTitle: 'General Information',
      parent1: {
        title: 'Parent 1',
        fields: {
          firstName: {
            label: 'First Name',
            value: '',
            rules: [
              v => !!v.trim() || 'First name is required'
            ]
          },
          lastName: {
            label: 'Last Name',
            value: '',
          },
          gender: {
            label: 'Gender',
            value: ''
          },
          dob: {
            label: 'Date of Birth',
            value: null,
            picker: false
          },
          ethinicity: {
            label: 'Ethinicity',
            value: ''
          },
          education: {
            label: 'Education',
            value: ''
          },
          religion: {
            label: 'Religion',
            value: ''
          },
          occupuation: {
            label: 'Occupation',
            value: ''
          }
        }
      },
      parent2: {
        title: 'Parent 2',
        fields: {
          firstName: {
            label: 'First Name',
            value: ''
          },
          lastName: {
            label: 'Last Name',
            value: ''
          },
          gender: {
            label: 'Gender',
            value: ''
          },
          dob: {
            label: 'Date of Birth',
            value: null,
            picker: false
          },
          ethinicity: {
            label: 'Ethinicity',
            value: ''
          },
          education: {
            label: 'Education',
            value: ''
          },
          religion: {
            label: 'Religion',
            value: ''
          },
          occupuation: {
            label: 'Occupation',
            value: ''
          }
        }
      },
      data: {
        genders: [
          'Male',
          'Female',
          'Female to Male',
          'Male to Female',
          'In Transition',
          'Other',
          'Unknown'
        ],
        educations: [
          'High School',
          'Some College',
          'College Degree',
          'Advanced Degree'
        ],
        // waitingFors: [
        //   'Less than 6 months',
        //   'Between 6 - 12 months',
        //   '3 years',
        //   '2 years',
        //   '1 year',
        //   'more than 4 years'
        // ],
        familyStructures: [
          'Life partner',
          'Living with life partner',
          'Living with life partner with no children',
          'Living with life partner with biological and adoptive children',
          'Married with biological and adopted children',
          'Married with only adopted children',
          'Married with only biological children',
          'Married with no children',
          'Single with biological and adopted children',
          'Single with only adopted children',
          'Single with only biological children',
          'Single with no children'
        ],
        houseTypes: [
          'Apartment',
          'Condominium',
          'Townhouse',
          'Single Family Home'
        ],
        neighbourhoods: [
          'Rural',
          'Suburban',
          'Urban'
        ],
        childrens: [
          { text: 'No Children', value: 0 },
          { text: '1 Child', value: 1 },
          { text: '2 Children', value: 2 },
          { text: '3 Children', value: 3 },
          { text: '4 Children', value: 4 },
          { text: '5 Children', value: 5 },
          { text: '6 Children', value: 6 }],
        // ages: [
        //   'Newborn - 3 months',
        //   'Newborn - 6 months',
        //   'Newborn - 9 months',
        //   'Newborn',
        //   '1 year old',
        //   '2 years old',
        //   '3 years old',
        //   '4 years old',
        //   '5 years old',
        //   '6 years old',
        //   '7 years old',
        //   '8 years old',
        //   'Over 8 years old'
        // ],
        pets: [
          'Cat',
          'Dog',
          'Other',
          'No Pet'
        ],
        ethnicities: [
          'African American',
          'African American/Asian',
          'African American/Native American',
          'Asian',
          'Asian/Hispanic',
          'Asian/Native American',
          'Bi-Racial',
          'Caucasian',
          'Caucasian/African American',
          'Caucasian/Hispanic',
          'Caucasian/Asian',
          'Caucasian/Native American',
          'European',
          'Hispanic',
          'Hispanic/African American',
          'Hispanic/Native American',
          'Middle Eastern',
          'Native American',
          'Pacific Islander',
          'Persian'
        ],
        religions: [
          'Anglican',
          'Atheist',
          'Bahai',
          'Baptist',
          'Buddhist',
          'Catholic',
          'Christian',
          'Church of Christ',
          'Episcopal',
          'Hindu',
          'Jewish',
          'Lutheran',
          'Mormon',
          'Methodist',
          'Muslim',
          'None',
          'Non-denominational',
          'Other',
          'Presbyterian',
          'Protestant',
          'The Church of Jesus Christ of Latter-Day Saints',
          'Unitarian'
        ]
      }
    }
  }),
  computed: {
    ...mapGetters([]),

    Account: {
      get () {
        return store.state.Account;
      },
      set (value) {
        store.commit('setAccount', value);
      }
    }
  },
  watch: {
    accountDetails: {
      handler: function (after, before) {
        this.parent1DobFormatted = this.formatDate((this.accountDetails.human[0].birth_date));
        if (this.accountDetails.account_type === 'Couple') {
          this.parent2DobFormatted = this.formatDate((this.accountDetails.human[1].birth_date));
        }
      },
      deep: true
    }
  },
  created () {
    this.initialize();
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  methods: {
    initialize () {
      this.accountDetails = JSON.parse(JSON.stringify(this.Account));
      this.previousPetsList = this.accountDetails.pets;
      this.accountDetails.human[0].birth_date = (this.accountDetails.human[0].birth_date).substr(0, 10);
      if (this.accountDetails.account_type === 'Couple' && this.accountDetails.human.length === 2) {
        this.accountDetails.human[1].birth_date = (this.accountDetails.human[1].birth_date).substr(0, 10);
      } else if (this.accountDetails.account_type === 'Couple') {
        this.accountDetails.human.push({
          birth_date: '',
          education: '',
          ethnicity: '',
          first_name: '',
          gender: 'Unknown',
          last_name: '',
          occupation: '',
          religion: ''
        });
      }
    },
    parent2FirstNameRule (value) {
      if (this.accountDetails.account_type === 'Couple' && value.trim().length === 0) {
        return 'First name is required';
      } else {
        return false;
      }
    },
    // eslint-disable-next-line complexity
    async save () {
      if (this.isFormDataChanged && this.$refs.aboutForm.validate()) {

        let isError = false;
        // Update the human[0]
        this.accountDetails.human[0].ethnicity = this.accountDetails.human[0].ethnicity || '';
        this.accountDetails.human[0].education = this.accountDetails.human[0].education || '';
        this.accountDetails.human[0].religion = this.accountDetails.human[0].religion || '';
        let { error, data, status } = await update('Human', this.accountDetails.human[0], this.accountDetails.human[0].id);
        if (error) {
          console.log('error', error);
          isError = true;
        } else {
          this.accountDetails.human[0] = data;
        }
        if (this.accountDetails.account_type === 'Single') {
          if (this.accountDetails.human.length === 2) {

            let { error, data, status } = await remove('Human', this.accountDetails.human[1].id);
            if (error) {
              console.log('error', error);
              isError = true;
            } else {
              this.accountDetails.human.pop();
            }
          }
        } else if (this.accountDetails.account_type === 'Couple') {
          if (this.accountDetails.human.length === 2 && typeof this.accountDetails.human[1].id !== 'undefined') {
            // Update the human[1]
            this.accountDetails.human[1].ethnicity = this.accountDetails.human[1].ethnicity || '';
            this.accountDetails.human[1].education = this.accountDetails.human[1].education || '';
            this.accountDetails.human[1].religion = this.accountDetails.human[1].religion || '';
            let { error, data, status } = await update('Human', this.accountDetails.human[1], this.accountDetails.human[1].id);
            if (error) {
              console.log('error', error);
              isError = true;
            } else {
              this.accountDetails.human[1] = data;
            }
          } else {
            // Create the human[1]
            this.accountDetails.human[1].ethnicity = this.accountDetails.human[1].ethnicity || '';
            this.accountDetails.human[1].education = this.accountDetails.human[1].education || '';
            this.accountDetails.human[1].religion = this.accountDetails.human[1].religion || '';
            let { error, data, status } = await create('Human', this.accountDetails.human[1]);
            if (error) {
              console.log('error', error);
              isError = true;
            } else {
              this.accountDetails.human[1] = data;
            }
          }
        }
        // Update the account name:
        if (this.accountDetails.account_type === 'Single') {
          this.accountDetails.name = this.accountDetails.human[0].first_name;
          if (this.accountDetails.human[0].religion) this.accountDetails.religion = [this.accountDetails.human[0].religion];
        } else {
          if (this.accountDetails.human[0].religion && this.accountDetails.human[1].religion) this.accountDetails.religion = [this.accountDetails.human[0].religion, this.accountDetails.human[1].religion];
          else if (this.accountDetails.human[0].religion) this.accountDetails.religion = [this.accountDetails.human[0].religion];
          else if (this.accountDetails.human[1].religion) this.accountDetails.religion = [this.accountDetails.human[1].religion];
          this.accountDetails.name = `${this.accountDetails.human[0].first_name} / ${this.accountDetails.human[1].first_name}`;
        }
        // Update the account
        this.Account = this.accountDetails;
        this.Account.family_structure = this.Account.family_structure || '';
        this.Account.house_style = this.Account.house_style || '';
        this.Account.neighbourhood_like = this.Account.neighbourhood_like || '';
        if (this.Account.children_count === null) {
          delete this.Account.children_count;
        }
        this.Account.updated_from = 'parentInfo';
        let accountUpdate = await update('Account', this.Account, session.getSession().adminUser ? session.getSession().user.human.account.id : 'Me');
        error = accountUpdate.error;
        data = accountUpdate.data;
        status = accountUpdate.status;
        if (error) {
          console.log('error', error);
          isError = true;
        }
        // Show the resultant response to the user
        if (isError) {
          this.isFormDataChanged = true;
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Unable to save your data, please try again.'
          };
        } else {
          this.loading = false;
          swal.fire({
            type: 'success',
            title: 'Parent information updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.isFormDataChanged = false;
              store.commit('setAccount', data);
              this.initialize();
            }
          });
        }
      }
    },
    hideButtons () {
      this.isFormDataChanged = false;
      this.accountDetails = JSON.parse(JSON.stringify(this.Account));
      this.previousPetsList = this.accountDetails.pets;
      this.accountDetails.human[0].birth_date = (this.accountDetails.human[0].birth_date).substr(0, 10);
      if (this.accountDetails.account_type === 'Couple') {
        this.accountDetails.human[1].birth_date = (this.accountDetails.human[1].birth_date).substr(0, 10);
      }
    },
    formatDate (date) {
      if (!date) return '';
      const [year, month, day] = date.split('-');
      return `${month}/${day}/${year}`;
    },
    parseDate (date) {
      if (!date) return '';
      const [month, day, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    changeAccountType (accountType) {
      this.isFormDataChanged = true;
      if (accountType === 'Couple') {
        if (this.accountDetails.human.length === 1) {
          this.accountDetails.human.push({
            birth_date: '',
            education: '',
            ethnicity: '',
            first_name: '',
            gender: 'Unknown',
            last_name: '',
            occupation: '',
            religion: ''
          });
        } else {
          this.accountDetails.human[1].birth_date = (this.accountDetails.human[1].birth_date).substr(0, 10);
        }
      } else {
        if (this.accountDetails.human.length === 2) {
          this.accountDetails.human.pop();
        }
      }
    },
    changePets (updatedPetsList) {
      this.isFormDataChanged = true;
      let before = [...this.previousPetsList] || [];
      let after = updatedPetsList;
      if (after.includes('No Pet') && !before.includes('No Pet')) {
        this.accountDetails.pets = ['No Pet'];
      } else if (after.includes('No Pet') && before.includes('No Pet')) {
        this.accountDetails.pets.splice(this.accountDetails.pets.indexOf('No Pet'), 1);
      }
      this.previousPetsList = [...this.accountDetails.pets];
    }
  }
};
</script>

<style lang="css" scoped>

  .button-container{
    min-height: 60px;
  }
  .account-type{
    padding-top: 2px;
  }
  .switch-account{
    padding-top: 5px;
  }

  .switch-cover {
    cursor: pointer;
    float:left;
  }
  .switch-cover input {
      position: absolute;
      opacity: 0;
  }
  .checkmark {
      background-color: #eff0f4;
      padding: 6px 20px;
  }
  .switch-cover:hover input ~ .checkmark {
    background-color: #ccc;
  }
  .switch-cover input:checked ~ .checkmark {
    background-color: #019d8c;
    color: #fff;
  }
  .switch-cover input:checked ~ .checkmark:after {
    display: block;
  }
  @media(max-width:410px){
    .switch-account{
      padding-right: 0 !important;
      width: 100%;
      padding-bottom: 15px;
    }
    .pf-btn{
      min-width: 85px;
    }
  }
  @media(min-width: 600px) and (max-width:699px){
    .switch-account{
      padding-right: 0 !important;
      width: 100%;
      padding-bottom: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/AboutUs.vue